import { connect } from 'react-redux';
import { saveSearch } from '../../actions/ProfileAction';
import SearchTab from '../presentation/SearchTab'; 

const mapStateToProps = (state) => {
    return {
        documents: state?.documents?.visiblelist,
    };
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveSearch: (criteria) => {
            dispatch(saveSearch(criteria));
        }
    };
};

const searchTabView = connect(mapStateToProps, mapDispatchToProps)(SearchTab);

export default searchTabView;